export { default as LegacyApiEvent, LegacyApiEvents } from "./events.js";
export { default } from "./LegacyApi.js";
//# sourceMappingURL=index.js.map